export default function FeaturesSection() {
  const features = [
    {
      id: 1,
      icon: 'ri-rocket-2-line',
      title: '极速直达入口',
      desc: '51动漫官网提供多线路官方直达入口，一键进入51动漫网与51动漫网站，无需复杂跳转即可快速观看动漫资源。',
    },
    {
      id: 2,
      icon: 'ri-film-line',
      title: '海量动漫资源',
      desc: '收录超过3000部国产动漫作品，涵盖热血、恋爱、奇幻、搞笑等多元题材，51动漫主页持续扩充资源库。',
    },
    {
      id: 3,
      icon: 'ri-timer-flash-line',
      title: '实时番剧更新',
      desc: '每日追踪最新动漫番剧更新动态，确保51动漫用户能在第一时间追到最新话，不遗漏任何精彩内容。',
    },
    {
      id: 4,
      icon: 'ri-shield-check-line',
      title: '安全稳定访问',
      desc: '51动漫官方认证入口，采用安全稳定的服务架构，保障用户在浏览51动漫网站时的流畅体验与数据安全。',
    },
    {
      id: 5,
      icon: 'ri-smartphone-line',
      title: '多端适配观看',
      desc: '51动漫平台全面适配桌面端与移动端，支持手机、平板随时随地追番，国产动漫入口随手可达。',
    },
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择51动漫
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大核心优势，为你打造最优质的国产动漫观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}